import React, { useState, useEffect } from "react";
import { 
  FaUtensils, 
  FaDumbbell, 
  FaSpa, 
  FaGlassMartiniAlt,
  FaChalkboardTeacher,
  FaSwimmingPool,
  FaParking,
  FaWifi
} from "react-icons/fa";

export default function HotelFormStep2({ hotelData, setHotelData, errors, onValidationChange = () => {} }) {
  const [localErrors, setLocalErrors] = useState({});
  const [isValid, setIsValid] = useState(false);

  // Validate form whenever hotelData changes
  useEffect(() => {
    validateForm();
  }, [hotelData]);

  const validateForm = () => {
    const newErrors = {};
    let formIsValid = true;

    // Validate Number of Rooms
    if (!hotelData.NumberOfRooms ) { //|| hotelData.NumberOfRooms === ""
      newErrors.NumberOfRooms = "Number of rooms is required";
      formIsValid = false;
    } else if (isNaN(parseInt(hotelData.NumberOfRooms))) {
      newErrors.NumberOfRooms = "Must be a valid number";
      formIsValid = false;
    } else if (Number(hotelData.NumberOfRooms) <= 0) {
      newErrors.NumberOfRooms = "Must be greater than 0";
      formIsValid = false;
    }

    setLocalErrors(newErrors);
    setIsValid(formIsValid);
    onValidationChange(formIsValid); // Safely call with default function if not provided
  };

  const handleChange = e => {
    setHotelData(p => ({ ...p, [e.target.name]: e.target.value }));
  };

  const handleNumberChange = e => {
    const value = e.target.value;
    setHotelData(p => ({ ...p, NumberOfRooms: value }));
  };

  const handleBlur = () => {
    validateForm();
  };

  const handleAmenitiesChange = e => {
    const { value, checked } = e.target;
    let a = [...(hotelData.Amenities || [])];
    if (checked) a.push(value);
    else a = a.filter(x => x !== value);
    setHotelData(p => ({ ...p, Amenities: a }));
  };

  const amenityOptions = [
    { name: "Restaurant", icon: <FaUtensils /> },
    { name: "Gym", icon: <FaDumbbell /> },
    { name: "Spa", icon: <FaSpa /> },
    { name: "Bar", icon: <FaGlassMartiniAlt /> },
    { name: "Conference Room", icon: <FaChalkboardTeacher /> },
    { name: "Swimming Pool", icon: <FaSwimmingPool /> },
    { name: "Parking", icon: <FaParking /> },
    { name: "Free Wi-Fi", icon: <FaWifi /> }
  ];

  const amenities = hotelData.Amenities || [];

  return (
    <div className="hotel-form-step2">
      <h2>Amenities - Step 2</h2>
      
      <div className="form-group">
        <label>Type</label>
        <input 
          name="Type" 
          value={hotelData.Type || ""} 
          onChange={handleChange} 
        />
        {errors?.Type && <p className="error-message">{errors.Type}</p>}
      </div>
      
      <div className="form-group">
        <label>Number of Rooms *</label>
        <input 
          type="number" 
          name="NumberOfRooms" 
          min="1"
          required
          value={hotelData.NumberOfRooms ?? ""} 
          onChange={handleNumberChange}
          onBlur={handleBlur}
        />
        {localErrors.NumberOfRooms && (
          <p className="error-message">{localErrors.NumberOfRooms}</p>
        )}
        {errors?.NumberOfRooms && (
          <p className="error-message">{errors.NumberOfRooms}</p>
        )}
      </div>
      
      <fieldset className="form-group amenities-group">
        <legend>Amenities</legend>
        <div className="amenities-grid">
          {amenityOptions.map(({ name, icon }) => (
            <label key={name} className="amenity-item">
              <input 
                type="checkbox" 
                name="Amenities" 
                value={name} 
                checked={amenities.includes(name)} 
                onChange={handleAmenitiesChange} 
              />
              <span className="amenity-icon">{icon}</span>
              <span className="amenity-name">{name}</span>
            </label>
          ))}
        </div>
      </fieldset>

      <style jsx>{`
        .amenities-group {
          border: 1px solid #ddd;
          padding: 15px;
          border-radius: 5px;
        }
        
        .amenities-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
          gap: 15px;
          margin-top: 10px;
        }
        
        .amenity-item {
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
        }
        
        .amenity-icon {
          font-size: 1.2rem;
          color: #555;
        }
        
        .amenity-name {
          font-size: 0.9rem;
        }
        
        input[type="checkbox"] {
          margin-right: 5px;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .error-message {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 5px;
        }
        
        label[for="NumberOfRooms"]::after {
          content: " *";
          color: #dc3545;
        }
      `}</style>
    </div>
  );
}